module.exports = __webpack_public_path__ + "static/media/Schritt_4_Gespraech_mit_dem_Zimmernachbarn.b1f6cc5e.pdf";